// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BanicoinCard_card__EdAoJ {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.BanicoinCard_inner__LDKEs {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  color: rgb(255, 255, 255);
  border-radius: 24px;
  border: 2px solid rgba(255, 255, 255, 0.24);
  background: rgba(255, 255, 255, 0.1);


  
  /* Card shadows */
  box-shadow: -105px 67px 35px 0px rgba(0, 3, 15, 0),
    -67px 43px 32px 0px rgba(0, 3, 15, 0.01),
    -38px 24px 27px 0px rgba(0, 3, 15, 0.04),
    -17px 11px 20px 0px rgba(0, 3, 15, 0.07),
    -4px 3px 11px 0px rgba(0, 3, 15, 0.08);
  max-width: 500px;
  min-width: 320px;
  min-height: 150px;
}
.BanicoinCard_content__VcfDt {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  /* background-image: url(/public/assets/layout/login-lone-mobile.png); */
  background-size: cover;
  background-position: center;
  padding: 1rem;
  height: 100%;
}
.BanicoinCard_title__PNrpz {
  color: #fff;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 450;
  line-height: 20px;
  margin-bottom: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 4px;
}
.BanicoinCard_title__PNrpz img {
  width: 16px;
  height: 16px;
}

.BanicoinCard_description__KPhIt {
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 8px;
}
.BanicoinCard_banicoin__sGC9A {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 12px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.16);
  padding: 8px 16px;
}
.BanicoinCard_banicoin-right__ut1uG {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
}
.BanicoinCard_banicoin-left__cUs25 {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.BanicoinCard_banicoin-buy__3xsfB {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #0c1213;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  padding: 8px 4px;
  border-radius: 34px;
  background: #fff;
  gap: 4px;
  width: 100%;
}
.BanicoinCard_expire__snXK5 {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;
  font-feature-settings: "ss01" on;
  /* font-family: "Yekan Bakh VF"; */
  font-size: 12px;
  font-style: normal;
  font-weight: 450;
  line-height: 20px;
}
@media screen and (min-width: 1000px) {
  .BanicoinCard_title__PNrpz {
    font-size: 18px;
  }
  .BanicoinCard_banicoin-left__cUs25,
  .BanicoinCard_banicoin-right__ut1uG,
  .BanicoinCard_expire__snXK5 {
    font-size: 16px;
  }
  .BanicoinCard_description__KPhIt {
    font-size: 14px;
  }
  .BanicoinCard_inner__LDKEs {
    max-width: 468px;
    min-width: 376px;
    min-height: 210px;
    justify-content: space-between;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DiscountCard/BanicoinCard/BanicoinCard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,oCAAoC;;;;EAIpC,iBAAiB;EACjB;;;;0CAIwC;EACxC,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,wEAAwE;EACxE,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,YAAY;AACd;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EAEnB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;EACR,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;EACjB;EACA;;;IAGE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,8BAA8B;EAChC;AACF","sourcesContent":[".card {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n.inner {\n  display: flex;\n  position: relative;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n  color: rgb(255, 255, 255);\n  border-radius: 24px;\n  border: 2px solid rgba(255, 255, 255, 0.24);\n  background: rgba(255, 255, 255, 0.1);\n\n\n  \n  /* Card shadows */\n  box-shadow: -105px 67px 35px 0px rgba(0, 3, 15, 0),\n    -67px 43px 32px 0px rgba(0, 3, 15, 0.01),\n    -38px 24px 27px 0px rgba(0, 3, 15, 0.04),\n    -17px 11px 20px 0px rgba(0, 3, 15, 0.07),\n    -4px 3px 11px 0px rgba(0, 3, 15, 0.08);\n  max-width: 500px;\n  min-width: 320px;\n  min-height: 150px;\n}\n.content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  /* background-image: url(/public/assets/layout/login-lone-mobile.png); */\n  background-size: cover;\n  background-position: center;\n  padding: 1rem;\n  height: 100%;\n}\n.title {\n  color: #fff;\n  text-align: right;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 450;\n  line-height: 20px;\n  margin-bottom: 12px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  gap: 4px;\n}\n.title img {\n  width: 16px;\n  height: 16px;\n}\n\n.description {\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  margin-bottom: 8px;\n}\n.banicoin {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 12px;\n  border-radius: 8px;\n  background: rgba(0, 0, 0, 0.16);\n  padding: 8px 16px;\n}\n.banicoin-right {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n  text-align: right;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px; /* 142.857% */\n}\n.banicoin-left {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n}\n.banicoin-buy {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #fff;\n  color: #0c1213;\n  text-align: right;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  padding: 8px 4px;\n  border-radius: 34px;\n  background: #fff;\n  gap: 4px;\n  width: 100%;\n}\n.expire {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  text-align: center;\n  font-feature-settings: \"ss01\" on;\n  /* font-family: \"Yekan Bakh VF\"; */\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 450;\n  line-height: 20px;\n}\n@media screen and (min-width: 1000px) {\n  .title {\n    font-size: 18px;\n  }\n  .banicoin-left,\n  .banicoin-right,\n  .expire {\n    font-size: 16px;\n  }\n  .description {\n    font-size: 14px;\n  }\n  .inner {\n    max-width: 468px;\n    min-width: 376px;\n    min-height: 210px;\n    justify-content: space-between;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `BanicoinCard_card__EdAoJ`,
	"inner": `BanicoinCard_inner__LDKEs`,
	"content": `BanicoinCard_content__VcfDt`,
	"title": `BanicoinCard_title__PNrpz`,
	"description": `BanicoinCard_description__KPhIt`,
	"banicoin": `BanicoinCard_banicoin__sGC9A`,
	"banicoin-right": `BanicoinCard_banicoin-right__ut1uG`,
	"banicoin-left": `BanicoinCard_banicoin-left__cUs25`,
	"banicoin-buy": `BanicoinCard_banicoin-buy__3xsfB`,
	"expire": `BanicoinCard_expire__snXK5`
};
export default ___CSS_LOADER_EXPORT___;
